import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';

import { IAvatarFactory } from './avatar-factory.interface';
import { CompanyAvatarFactory } from './company-avatar-factory';
import { UserAvatarFactory } from './user-avatar-factory';
import { Company, User } from '../../models/context.model';

@Component({
	selector: 'ui-avatar-image',
	templateUrl: './ui-avatar-image.component.html',
	styleUrls: ['./ui-avatar-image.scss'],
	standalone: true
})
export class UiAvatarImageComponent implements OnChanges {
	@Input() public sourceType: 'User' | 'Company' = 'User';
	@Input() public source: User | Company = new User();
	@Input() public big: boolean = false;

	public imagePath: string = '';
	public innerText: string = '';
	public style: any;
	private factory: IAvatarFactory | undefined;
	private colorsList = [
		'#5c67c1',
		'#455960',
		'#be3509',
		'#c03611',
		'#008ad5',
		'#f06d03',
		'#c5175c',
		'#ea3c77',
		'#00599a',
		'#502ea9',
		'#028b79',
		'#5d403a',
		'#6b9c40',
		'#896f62',
		'#c1360c',
		'#c4175b',
		'#03589b',
		'#ea417a',
		'#788f9a',
		'#0488d2'
	];

	constructor() {}

	public ngOnChanges(changes: SimpleChanges) {
		if (changes['source'] && this.source) {
			this.factory = this.createFactory();
			this.createImage();
		}
	}

	public createImage() {
		this.imagePath = this.factory?.getImagePath() ?? '';
		this.checkImagePath();
	}

	public errorHandler() {
		this.imagePath = '';
		this.checkImagePath();
	}

	public checkImagePath() {
		if (!this.imagePath) {
			this.style = this.getLetterStyle();
			this.innerText = this.factory?.getLetter() ?? '';
		}
	}

	public getLetterStyle(): any {
		const color = this.factory?.getRandomColor(this.colorsList) ?? '';
		return { backgroundColor: color, color: this.getForegroundColor(color) };
	}

	public getForegroundColor(color: string): string {
		const rgb = this.hexToRgb(color);
		const a = 1 - (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;

		return a < 0.5 ? '#404040' : '#f1f1f1';
	}

	private hexToRgb(hex: string): any {
		const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
		hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);

		const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
		return result
			? {
					r: parseInt(result[1], 16),
					g: parseInt(result[2], 16),
					b: parseInt(result[3], 16)
			  }
			: null;
	}

	private createFactory(): IAvatarFactory {
		if (this.sourceType === 'User') {
			return new UserAvatarFactory(<User>this.source);
		} else {
			return new CompanyAvatarFactory(<Company>this.source);
		}
	}
}
